console.log('From article component!!!');